import { Component, Input } from '@angular/core';

@Component({
  selector: 'kui-label-flag',
  templateUrl: './label-flag.component.html',
  styleUrls: ['./label-flag.component.scss'],
})
export class LabelFlagComponent {
  @Input() backgroundColor: string;
  @Input() color: string;
  @Input() flip: boolean;
}
